"use client";

import { FileCode, FolderTree, LineChart } from "lucide-react";

export default function CustomIndicatorEditorEmptyView() {
  return (
    <div className="flex h-full min-h-0 flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="flex items-center gap-3 text-muted-foreground/60">
        <FolderTree className="h-8 w-8" strokeWidth={1.25} />
        <FileCode className="h-8 w-8" strokeWidth={1.25} />
        <LineChart className="h-8 w-8" strokeWidth={1.25} />
      </div>
      <div className="space-y-1">
        <p className="text-sm font-medium text-foreground">Nothing to view</p>
        <p className="max-w-sm text-xs text-muted-foreground">
          Select what to view using the toolbar toggles next to Exit.
        </p>
      </div>
    </div>
  );
}
